/**
 * Configuración unificada para el selector de preguntas en Descargas Masivas
 * Define el filtrado de preguntas y grupos
 */

export const FORM_CONFIG = {
  // Configuración de búsqueda y filtrado de preguntas
  search: {
    // 1. Filtrar por TIPO de pregunta (type)
    excludeSearchByType: ['note', 'start-geopoint', 'today', 'subscriberid'],
    
    // 2. Filtrar por NOMBRE de pregunta (name)
    excludeSearchByName: [
      'deviceid',
      'start',
      'end',
      'username',
      'simserial',
      'phonenumber',
      'productor_cargo_coop',
      'productor_cargo_mision',
    ],

    excludeSearchByNameConfig: {
      enabled: true,
      exactMatch: true,
      caseSensitive: true
    },
    
    // 3. Filtrar por ETIQUETA de pregunta (label)
    excludeSearchByLabel: []
  }
};

export const MENU_CONFIG = {
  // 4. Filtrar por NOMBRE DE GRUPO (group name)
  groupNameFiltering: {
    enabled: true,
    
    // true (Lista blanca): SOLO mostrar los grupos que estén en la lista
    // false (Lista negra): OCULTAR los grupos que estén en la lista
    useAsWhitelist: false,
    
    // Lista de nombres de grupos para filtrar

    list: [
        'privacidad_grupo',
        'sa_acta_acuerdo_cert_grupo',
        'productor_datos_nuevos_grupo',
        'encuesta_admin',
        'info_parcela',
        'validacion_info'
    ],
    
    // Usar coincidencia exacta o parcial
    exactMatch: false,
    
    // Distinguir mayúsculas y minúsculas
    caseSensitive: false,
    
    // También filtrar por la ruta completa del grupo (ej: 'grupo_padre/subgrupo')
    includeGroupPath: true,
    
    // Configuración de debug
    debug: {
      enabled: false,
      showInConsole: false
    }
  }
};

export const GROUP_LABEL_OVERRIDES = {
  info_parcela: 'Información general del productor',
  encuesta_admin: 'Encuesta de administrador',
};

export const QUESTION_LABEL_OVERRIDES = {
  productor_nombre: 'Nombre del productor',
  productor_fecha_ingreso: 'Fecha de ingreso del productor',
  productor_curp: 'CURP del productor',
  productor_rfc: 'RFC del productor',
  productor_celular: 'Número de celular del productor',
  productor_ine: 'INE del productor',
  productor_ciudad: 'Ciudad del productor',
  productor_clave_socio: 'Clave socio del productor',
  productor_categoria: 'Categoria del productor'
};

export const GROUP_PRESELECTION_CONFIG = {
  enabled: true,
  groups: ['info_parcela'],
  exactMatch: true,
  caseSensitive: false,
  includeGroupPath: true
};

export const QUESTION_PRESELECTION_CONFIG = {
  enabled: false,
  names: [],
  exactMatch: true,
  caseSensitive: false
};

/**
 * Evalúa si un grupo debe ser filtrado basándose en su nombre
 * @param {Object} grupo - Objeto del grupo con propiedades como name
 * @param {Object} filterConfig - Configuración de filtrado (opcional)
 * @returns {boolean} - true si el grupo debe ser ocultado, false si debe mostrarse
 */
export const shouldFilterGroupByName = (grupo, filterConfig = null) => {
  const config = filterConfig || MENU_CONFIG.groupNameFiltering;
  
  if (!config.enabled) return false;
  if (!config.list || config.list.length === 0) return false;
  if (!grupo || !grupo.name) return false;
  
  const groupName = config.caseSensitive ? grupo.name : grupo.name.toLowerCase();
  
  // Verificar si el nombre del grupo está en la lista
  const isInList = config.list.some(filterName => {
    const compareWith = config.caseSensitive ? filterName : filterName.toLowerCase();
    if (config.exactMatch) {
      return groupName === compareWith;
    } else {
      return groupName.includes(compareWith);
    }
  });
  
  // Verificar por ruta si está habilitado
  let isInPathList = false;
  if (config.includeGroupPath && grupo.path) {
    const groupPath = config.caseSensitive ? grupo.path : grupo.path.toLowerCase();
    isInPathList = config.list.some(filterName => {
      const compareWith = config.caseSensitive ? filterName : filterName.toLowerCase();
      if (config.exactMatch) {
        return groupPath.includes(`/${compareWith}/`) || groupPath.endsWith(`/${compareWith}`);
      } else {
        return groupPath.includes(compareWith);
      }
    });
  }
  
  const matchFound = isInList || isInPathList;
  
  if (config.debug && config.debug.enabled && config.debug.showInConsole) {
    // console.log(`🔍 [GROUP FILTER] Grupo: "${grupo.name}", En lista: ${matchFound}, Acción: ${config.useAsWhitelist ? (matchFound ? 'MOSTRAR' : 'OCULTAR') : (matchFound ? 'OCULTAR' : 'MOSTRAR')}`);
  }
  
  return config.useAsWhitelist ? !matchFound : matchFound;
};
